import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { theme } from "Theme"
import YouTube from "@u-wave/react-youtube"
import Vimeo from "@u-wave/react-vimeo"

const Wrapper = styled.section`
  width: 100%;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
`

const BackgroundVideo = ({ youtubeId, vimeoId }) => (
  <Wrapper>
    <div className="video-section-youtube-background">
      <div className="video-section-youtube-foreground">
        {youtubeId && (
          <YouTube
            video={youtubeId}
            width={640}
            height={320}
            autoplay={false}
            modestBranding={true}
            muted={true}
            loop={1}
            showInfo={false}
            background={false}
            controls={true}
            className="video-iframe"
            showRelatedVideos={false}
          />
        )}
        {vimeoId && (
          <Vimeo
            video={vimeoId}
            width={640}
            height={320}
            // autoplay
            volume={0}
            // loop={true}
            background={false}
            controls={false}
            className="video-iframe"
          />
        )}
      </div>
    </div>
  </Wrapper>
)

export default BackgroundVideo

BackgroundVideo.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
}

BackgroundVideo.defaultProps = {
  children: false,
  image: false,
  title: false,
}
